import { Component, OnInit, OnDestroy } from '@angular/core';
import { EmployeeService } from '../../employee/services/employee.service';
import * as moment from 'moment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TrabajadorEditComponent } from './trabajador-edit/trabajador-edit.component';
import { DocumentsService } from '../services/documents.service';
import { LeaveService } from '../../leave/services/leave.service';
import { Subscription } from 'rxjs';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { MoverComponent } from './mover/mover.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { finalize } from 'rxjs/operators';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { DeleteMotivoComponent } from './delete-motivo/delete-motivo.component';
import Utils from 'app/Utils';


@Component({
    selector: 'app-trabajador',
    templateUrl: './trabajador.component.html',
    styleUrls: ['./trabajador.component.scss'],
    standalone: false
})
export class TrabajadorComponent implements OnInit, OnDestroy {
    EmployeeSubcription: Subscription;

    dialogRef: any;
    currentUser: any;
    editable = false;
    trabajador: any = {};
    formatedFnacimiento: any;
    formatedAddress: any;
    yearDiff: any;
    monthDiff: any;
    anoText: any;
    isLoading: boolean = true;
    private permissionIds: any[] = [];
    private editvalidation: boolean = false;
    BaajaDeeText: string;
    BajaDateHoverText: string;
    mesesText: string;
    consentimentoHouverText: string;
    showSeemore: boolean = false;
    infromationoHouverText: string;
    telephoneArray: any[] = [];
    formatedTelephoneArray: string;
    months: number;
    consent: string;
    formatedAngitudad: any;
    formatedFinContracto: any;
    address: string;

    hasPermisionToBlock = false;
    hasPermisionToUnblock = false;

    isPopupOpen = false;

    constructor(
        public employeeService: EmployeeService,
        public dialog: MatDialog,
        public documentService: DocumentsService,
        public leaveService: LeaveService,
        public employeeStoreService: EmployeeStoreService,
        public sharedService: SharedService,
    ) {

        this.EmployeeSubcription = this.employeeService.subTrabajador.subscribe(result => {
            this.isLoading = true;
            this.trabajador = result;

            this.hasPermisionToBlock = (this.trabajador.importacionId === null || this.trabajador.importacionId >= 0)
                && this.sharedService.Permissions.HasPermisos314;
            this.hasPermisionToUnblock = this.trabajador.importacionId < 0 && this.sharedService.Permissions.HasPermisos314;

            this.trabajador.absentismo = (this.trabajador.absentismo !== null || this.trabajador.absentismo === undefined) ? Math.ceil(this.trabajador.absentismo) : null;
            this.leaveService.PublishLeaves(result.trabajadorId);
            this.documentService.PublishDocuments(result.trabajadorId);
            this.getTrabajadorData(result);
        });

        this.employeeService.fromclosed.subscribe(Data => {
            this.dialogRef.close();
        });

        this.checkUserEditPermission();

    }


    clickSeeMore() {
        if (this.showSeemore == true) {
            this.showSeemore = false;
        }
        else
            this.showSeemore = true;
    }

    ngOnInit() {
        this.isLoading = true;
    }

    ngOnDestroy() {
        this.EmployeeSubcription.unsubscribe();
    }

    // showEditView(modal: string) {
    //   this.openDialog()
    // }

    getTrabajadorData(result) {
        this.formatedFnacimiento = "";
        this.isLoading = false;
        if (result.fnacimiento != null) {
            this.formatedFnacimiento = result.fnacimiento.split('T')[0];
        }
        const addressFirstLine = [];
        const addressSecondLine = [];
        let cpline = result.cp != null ? result.cp : "";
        let province = result.provincia != null ? '(' + result.provincia + ')' : "";

        if (result.direccion != null || result.direccion !== "") {
            addressFirstLine.push(result.direccion);
        }

        if (cpline != "") {

            let pob = result.poblacion != null ? result.poblacion : "";
            addressSecondLine.push(cpline, pob);
        }
        if (province != "") {
            addressSecondLine.push(province);
        }
        const addressArray = [addressFirstLine, addressSecondLine, result.obsDireccion != null ? result.obsDireccion : ""];
        this.formatedAddress = addressArray.join('\n');

        let fantiguedad;
        let ffinContrato;

        if (result.fantiguedad !== null) {
            fantiguedad = moment(result.fantiguedad.split('T')[0]);
        }
        if (result.ffinContrato !== null) {
            ffinContrato = moment(result.ffinContrato.split('T')[0]);
        }
        if (fantiguedad === undefined) {
            this.yearDiff = null;
            this.monthDiff = null;
            this.anoText = "";
            this.mesesText = "";
        } else {
            let startDate = null;
            let endDate = null;
            if (ffinContrato === undefined && ffinContrato == null) {
                startDate = fantiguedad;
                endDate = moment(new Date());
            } else {
                startDate = fantiguedad;
                endDate = ffinContrato;
            }
            this.formatedAngitudad = result.fantiguedad.split('T')[0];
            this.formatedFinContracto = endDate.format('YYYY-MM-DD');
            const differenceInMonths = Math.round(moment.duration(endDate.diff(startDate)).asMonths());
            this.yearDiff = Math.floor(differenceInMonths / 12);
            this.monthDiff = differenceInMonths % 12;
            if (this.yearDiff == 0 || this.yearDiff === undefined || this.yearDiff === null) {
                this.anoText = "";
            } else if (this.yearDiff === 1) {
                this.anoText = 'año';
            } else {
                this.anoText = 'años';
            }
            if (this.monthDiff == 0 || this.monthDiff === undefined || this.monthDiff === null) {
                this.mesesText = "";
            } else if (this.monthDiff === 1) {
                this.mesesText = 'mes';
            } else {
                this.mesesText = 'meses';
            }
            this.BajaDateHoverText = "F.Antigüedad: " + startDate.format('DD/MM/YYYY') + "." + " F.Fin.Contrato: " + endDate.format('DD/MM/YYYY');
        }
        if (result.ffinContrato != null) {
            const TodayDate = moment(new Date());
            let diffInDates = moment.duration(ffinContrato.diff(TodayDate)).asDays();
            if (diffInDates <= 0) {
                this.BaajaDeeText = "BAJA DE EMPRESA";
            }
            else {
                this.BaajaDeeText = "";
            }
        }

        if (result.tipoConsentimiento != null || result.consentimiento != null) {
            const addressArrayConssentimiento = [];
            let line1 = result.fconsGrabado !== null ? "Consentimiento grabado en " + moment(result.fconsGrabado).format('DD/MM/YYYY') : "";
            let line2 = result.fconsentimiento !== null ? "Consentimiento escrito en " + moment(result.fconsentimiento).format('DD/MM/YYYY') : "";
            let line3 = result.fentregaCons !== null ? "y entregado en " + moment(result.fentregaCons).format('DD/MM/YYYY') : "";

            if (line1 !== "") {
                addressArrayConssentimiento.push(line1);
            }
            if (line2 !== "") {
                addressArrayConssentimiento.push(line2);
            }
            if (line3 !== "") {
                addressArrayConssentimiento.push(line3);
            }

            if (result.telCancelado !== null) {
                let line4 = "Teléfono Cancelado ";
                addressArrayConssentimiento.push(line4);
                this.consentimentoHouverText = addressArrayConssentimiento.join('\n');
            }
            else {
                this.consentimentoHouverText = addressArrayConssentimiento.join('\n');
            }

            this.consent = this.GetConsent(result.tipoConsentimiento, result.consentimiento);

        }

        if (result.direccion != null || result.obsDireccion != null) {
            let line1 = result.direccion;
            let line2 = result.cp;
            let line3 = result.obsDireccion;
            if (result.direccion == null) {
                const addressArray = [line1, line3];
                this.infromationoHouverText = addressArray.join('\n');
            }

            const addressArray = [line1, line2, line3];
            this.infromationoHouverText = addressArray.join('\n');
        }

        if (result) {
            this.formatedTelephoneArray = "";
            this.telephoneArray = [];
            if (result.telefono1 != null && result.telefono1 != "") {
                this.telephoneArray.push(result.telefono1);
            }
            if (result.telefono2 != null && result.telefono2 != "") {
                this.telephoneArray.push(result.telefono2);
            }
            if (result.movil != null && result.movil != "") {
                this.telephoneArray.push(result.movil);
            }
            if (result.telefono4 != null && result.telefono4 != "") {
                this.telephoneArray.push(result.telefono4);
            }
            this.formatedTelephoneArray = this.telephoneArray.length > 0 ? this.telephoneArray.join(' / ') : "";
        }

        // text line validatation 

        //  if(result.obs)
    }

    checkUserEditPermission(): void {
        this.isLoading = true;
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (this.currentUser.permissionIds.includes(316)) {
            this.editable = true;
            this.isLoading = false;
        }
    }

    private GetConsent(tipoConsentimiento, consentimiento) {
        let result: string;
        switch (tipoConsentimiento) {
            case 'E':
                result = (consentimiento === 'E') ? 'Consentimiento escrito firmado' : 'Consentimiento escrito firmado y entregado';
                break;
            case 'G':
                result = 'Consentimiento grabado';
                break;
            case 'EG':
                result = (consentimiento === 'E') ? 'Consentimiento grabado, firmado y entregado' : 'Consentimiento grabado y firmado';
                break;
            default:
                {
                    if (consentimiento === 'S') {
                        result = 'Consentimiento firmado';
                    } else if (consentimiento === 'E') {
                        result = 'Consentimiento firmado y entregado';
                    }

                }
                break;
        }
        return result;
    }

    openDialog(): void {

        if (!this.isPopupOpen) {
            this.isPopupOpen = true;
            this.employeeService.GetTrabajador(this.trabajador.trabajadorId)
                .subscribe(res => {
                    this.employeeService.publishEditEmployee(res.result);

                    this.dialogRef = this.dialog.open(TrabajadorEditComponent, {
                        width: '900px',
                        autoFocus: true
                    });

                    this.dialogRef.afterClosed().subscribe(result => {
                        this.isPopupOpen = false;
                    });

                }, err => {
                    console.error(err);
                });
        }

    }


    // open empoyee move dialog
    openEmployeeMoveDialog(): void {

        if (!this.isPopupOpen) {
            this.isPopupOpen = true;
            this.dialogRef = this.dialog.open(MoverComponent, {
                width: '480px',
                autoFocus: true
            });

            this.dialogRef.afterClosed().subscribe(() => {
                this.isPopupOpen = false;
            });
        }

    }


    /**
     * Handle employee lock button click
     */
    onLockEmployeeClick() {

        // confirm before lock
        const dialogData = new ConfirmDialogModel('¿Marcar el trabajador para que por la noche quede bloqueado junto con todas sus bajas?', "");
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                this.lockEmployee(this.trabajador.trabajadorId);
            }
        });

    }


    /**
     * Locks an employee 
     */
    private lockEmployee(employeeId: number) {
        this.isLoading = true;
        this.employeeService.locksEmployee(employeeId)
            .pipe(finalize(() => {
                this.isLoading = false;
            }))
            .subscribe(res => {

                if (res.code === 0) {
                    this.sharedService.ShowSnackBar("el empleado se bloqueó correctamente");
                    this.refreshThisComponent();
                } else {
                    console.error("Server Error: " + res.message);
                    this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
                }

            }, err => {
                console.error("Unknown Error: " + err);
                this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
            });
    }


    /**
     * Handle employee unlock button click
     */
    onUnlockEmployeeClick() {

        this.isLoading = true;
        this.employeeService.UnlockEmployee(this.trabajador.trabajadorId)
            .pipe(finalize(() => {
                this.isLoading = false;
            }))
            .subscribe((res: RestResponse) => {

                if (res.code === 0) {
                    this.sharedService.ShowSnackBar("Empleada fue desbloqueada con éxito");
                    this.refreshThisComponent();
                } else {
                    console.error("Server Error: " + res.message);
                    this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
                }

            }, (err: string) => {
                console.error("Unknown Error: " + err);
                this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
            });

    }


    /**
     * Cancel employee data button click handler
     */
    onCancelEmployeeDataClick() {

        // confirm before cancel
        const dialogData = new ConfirmDialogModel('¿Cancelar los datos del trabajador?', "");
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                const companyId = parseInt(localStorage.getItem("Empresa"));
                this.cancelEmployeeData(this.trabajador.trabajadorId, companyId);
            }
        });

    }


    /**
     * Cancel employee data
     */
    private cancelEmployeeData(employeeId: number, companyId: number) {

        this.isLoading = true;

        this.employeeService.cancelEmployeeData(employeeId, companyId)
            .pipe(
                finalize(() => this.isLoading = false)
            )
            .subscribe(res => {

                if (res.code === 0) {
                    this.sharedService.ShowSnackBar("El proceso se terminó con éxito");
                    this.refreshThisComponent();
                } else {
                    console.error("Server Error: " + res.message);
                    this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
                }

            }, err => {
                console.error("Unknown Error: " + err);
                this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
            });

    }


    /**
     * Delete employee button click handler
     */
    onDeleteEmployeeDataClick() {

        // confirm before delete
        const dialogData = new ConfirmDialogModel('¿Eliminar definitivamente este trabajador, con todas sus bajas, actuaciones y tareas?', "");
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                this.dialog.open(DeleteMotivoComponent, { data: this.trabajador.trabajadorId });
            }
        });

    }


    /**
     * Refresh this employee component by re-providing current employee details
     */
    private refreshThisComponent() {
        this.employeeStoreService.updateAllEmployeeViews(this.trabajador.trabajadorId);
        window.location.reload();
    }

}
